import {Box} from '@mui/material';
import {useCustomeTheme} from './ThemeContext';
import {SecondaryTextSmall} from "./Typography";

export const ThemeSwitcher = ({onSwitch}) => {
  const {currentTheme, toggleTheme} = useCustomeTheme();

  const themes = [
    {
      key: 'default',
      name: 'Стандартная',
      primary: '#ffffff',
      secondary: '#1976d2'
    },
    {
      key: 'dark',
      name: 'Темная',
      primary: '#333',
      secondary: '#121212'
    },
    {
      key: 'meadow',
      name: 'Зеленая',
      primary: '#7cb342',
      secondary: '#2e7d32'
    },
    {
      key: 'barbie',
      name: 'Барби',
      primary: '#ffc0d3',
      secondary: '#ffd700'
    }
  ];

  const handleClick = (theme) => {
    toggleTheme(theme.key);

    onSwitch ? onSwitch(theme.key) : null;
  }

  return (
      <>
      {themes.map((theme) => (
        <Box key={theme.key} sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginRight: '10px',
          height: 88,
        }}>
            <Box
              onClick={() => handleClick(theme)}
              sx={{
                width: currentTheme === theme.key ? 79 : 80,
                height: 80,
                background: `linear-gradient(135deg, ${theme.primary} 50%, ${theme.secondary} 50%)`,
                borderRadius: 1,
                cursor: 'pointer',
                boxShadow: currentTheme === theme.key ? 0 : 2,
                border: currentTheme === theme.key ? '2px solid' : '1px solid',
                borderColor: currentTheme === theme.key ? 'primary.main' : 'grey.400',
                '&:hover': {
                  boxShadow: 2,
                  transition: 'all 0.2s ease-in-out'
                },
                position: 'relative',
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'center',
                pb: 0.5
              }}
            >
            </Box>
          <SecondaryTextSmall sx={{textAlign: 'center', mt: 0.5}}>
            {theme.name}
          </SecondaryTextSmall>
        </Box>
      ))}
    </>
  );
};